var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tips-class" },
    [
      _c(
        "el-tooltip",
        {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: _vm.$t("chart.field_error_tips"),
            placement: "bottom",
          },
        },
        [
          _c(
            "span",
            [_c("svg-icon", { attrs: { "icon-class": "icon_info_filled" } })],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }